export const FETCH_PREINVOICE_REQUEST = "FETCH_PREINVOICE_REQUEST";
export const FETCH_PREINVOICE_SUCCESS = "FETCH_PREINVOICE_SUCCESS";
export const FETCH_PREINVOICE_FAILURE = "FETCH_PREINVOICE_FAILURE";
